"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceCenterElement = exports.NoCertificates = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var _1 = require(".");

exports.NoCertificates = function (_a) {
  var expiredCertExists = _a.expiredCertExists,
      _b = _a.helpLinks,
      howToCopyPrivateKeyContainer = _b.howToCopyPrivateKeyContainer,
      howToInstallCertificate = _b.howToInstallCertificate,
      serviceCenter = _b.serviceCenter,
      error = _a.error,
      trackEvent = _a.trackEvent;
  var action = expiredCertExists ? _1.DisplayedErrorCodes.NoActiveCertificates : _1.DisplayedErrorCodes.NoValidCertificates; // выбираем заголовк ошибки в зависимости от наличия истекших сертификатов

  var title = expiredCertExists ? react_1.default.createElement("div", null, "\u0421\u0440\u043E\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0432\u0430\u0448\u0438\u0445 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438\u0441\u044C") : react_1.default.createElement("div", null, "\u0423\xA0\u0432\u0430\u0441 \u043D\u0430\xA0\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0435 \u043D\u0435\u0442\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432");
  /**
   * Выбираем текст и ссылку в зависимости от того доступна установка сертификатов или нет.
   * Если автоустановка сертификатов включена через параметры, плагин поддерживает установку,
   * то нет смысла давать ссылку на установку сертификата.
   */

  var onCopyClick = function onCopyClick() {
    trackEvent(action, 'howToCopyPrivateKeyContainerLinkClick');
  };

  var onInstallClick = function onInstallClick() {
    trackEvent(action, 'howToInstallCertificateLinkClick');
  };

  var certInstallAvailable = error.details && error.details.certInstallAvailable;
  var text = certInstallAvailable ? react_1.default.createElement("div", null, "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0444\u043B\u0435\u0448\u043A\u0443 \u0441\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u043C. \u0415\u0441\u043B\u0438 \u043E\u043D \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D \u043D\u0430\xA0\u0434\u0440\u0443\u0433\u043E\u043C \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0435,", ' ', react_1.default.createElement(Link_1.Link, {
    "data-tid": "howToCopyPrivateKeyContainerLink",
    onClick: onCopyClick,
    href: howToCopyPrivateKeyContainer,
    target: "_blank"
  }, "\u0441\u043A\u043E\u043F\u0438\u0440\u0443\u0439\u0442\u0435\xA0\u043F\u043E\xA0\u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438"), ".") : react_1.default.createElement("div", null, "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0444\u043B\u0435\u0448\u043A\u0443 \u0441\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u043C \u0438\u043B\u0438", ' ', react_1.default.createElement(Link_1.Link, {
    "data-tid": "howToInstallCertificateLink",
    onClick: onInstallClick,
    href: howToInstallCertificate,
    target: "_blank"
  }, "\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043F\u043E\xA0\u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438"), ".");

  var onServiceCenterClick = function onServiceCenterClick() {
    trackEvent(action, 'serviceCenterLinkClick');
  };

  return {
    title: title,
    message: react_1.default.createElement("div", null, text, react_1.default.createElement("br", null), "\u0415\u0441\u043B\u0438 \u0443\xA0\u0432\u0430\u0441 \u043D\u0435\u0442 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430, ", exports.serviceCenterElement(serviceCenter, onServiceCenterClick), ".")
  };
};

exports.serviceCenterElement = function (serviceCenter, onClick // используется для сбора метрик.
) {
  var scText = "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440";
  return serviceCenter ? react_1.default.createElement(Link_1.Link, {
    "data-tid": "serviceCenterLink",
    onClick: onClick,
    href: serviceCenter,
    target: "_blank"
  }, scText) : scText;
};